import React from "react";
import Logo from "./Logo";
import { Phone, Mail, MapPin, Globe } from "lucide-react";

const LINKS = [
  { href: "#hero", label: "Accueil" },
  { href: "#services", label: "Services" },
  { href: "#about", label: "À propos" },
  { href: "#contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0A1128] text-white pt-20 pb-8 relative overflow-hidden">
      <div className="absolute inset-0 topo-grid-bg opacity-50 pointer-events-none" />

      {/* Côte d'Ivoire silhouette with port night scene */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 flex items-center justify-end"
        data-testid="footer-ci-watermark"
      >
        <img
          src="https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/8ml0pde4_polish_save.png"
          alt=""
          className="h-full w-full lg:w-3/5 object-cover opacity-40 mix-blend-luminosity"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1128] via-[#0A1128]/85 to-transparent lg:from-[#0A1128] lg:via-[#0A1128]/60 lg:to-[#0A1128]/10" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-5">
            <Logo variant="footer" />
            <p className="mt-6 text-white/65 max-w-sm leading-relaxed">
              Votre partenaire maritime et logistique de confiance en Côte
              d'Ivoire.
            </p>
            <p className="mt-4 text-xs uppercase tracking-[0.25em] text-[#D90429]">
              KMS SERVICES PLUS · KMS SP SARL
            </p>
            <a
              href="https://www.kmsserviceplus.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-2 text-sm font-bold tracking-wide text-white/80 hover:text-[#D90429] transition-colors border-b border-white/20 hover:border-[#D90429] pb-1"
            >
              www.kmsserviceplus.com
            </a>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <div className="kms-overline" style={{ color: "#D90429" }}>Liens rapides</div>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-white/75 hover:text-[#D90429] transition-colors text-base font-medium"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="kms-overline" style={{ color: "#D90429" }}>Coordonnées</div>
            <ul className="mt-5 space-y-4 text-sm text-white/75">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#D90429] mt-1 flex-shrink-0" />
                <div className="space-y-1">
                  <div>+225 05 05 35 27 27</div>
                  <div>+225 07 79 14 85 08</div>
                  <div>+225 07 58 35 91 32</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#D90429] mt-1 flex-shrink-0" />
                <a href="mailto:supportkms@kmsserviceplus.com" className="hover:text-white break-all">
                  supportkms@kmsserviceplus.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Globe size={16} className="text-[#D90429] mt-1 flex-shrink-0" />
                <a
                  href="https://www.kmsserviceplus.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  www.kmsserviceplus.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#D90429] mt-1 flex-shrink-0" />
                <div>
                  Abidjan – Treichville, Avenue 13 Rue 40
                  <br />
                  <span className="text-white/50">05 BP 1972 Abidjan 05</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/45">
          <div>© 2026 KMS SERVICES PLUS — Tous droits réservés.</div>
          <div className="flex items-center gap-2">
            <span>RC :</span>
            <span className="font-mono text-white/70">CI-ABJ-03-2025-B13-09212</span>
            <span>· Capital 3 000 000 FCFA</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
